import React from 'react';
import {
  Box,
  Grid,
  ModalBody,
  RemoveAlertDialog,
  useDisclosure,
} from '@wegroup/design-system';
import AddInsuranceModalNavigation from './navigation/AddInsuranceModalNavigation';
import AddInsuranceModalForms from './AddInsuranceModalForms';
import { useTranslation } from 'react-i18next';
import { InsurancePolicyType } from '../../../../../../types/AdvisoryReport';
import { InsurancePolicyModalProps } from '../../hooks/useInsurancePolicyModal';
import useAddInsuranceModalContext from '../../hooks/useAddInsuranceModalContext';
import { groupBy } from 'lodash';
import { PartyType } from '../../../../../../../../../types/SMT';

interface Props {
  mode: 'ADD' | 'EDIT';
  type: InsurancePolicyType;
  insuranceModalProps: InsurancePolicyModalProps;
  partyType?: PartyType;
  hideAIBanner?: boolean;
}

const AddInsuranceModalBody: React.FC<Props> = ({
  mode,
  type,
  insuranceModalProps,
  partyType,
  hideAIBanner,
}) => {
  const { page, setPage, coverages, handleRemoveCoverage } =
    insuranceModalProps;
  const coveragesByRisk = groupBy(coverages, 'risk_object');
  const { t } = useTranslation();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const showNav = page.type === 'COVERAGE';
  const { riskObjects } = useAddInsuranceModalContext();
  const selectedRisk = page.index != null ? riskObjects[page.index] : undefined;

  return (
    <ModalBody
      p="0"
      h="100%"
      as={Grid}
      templateColumns={showNav ? '1fr 2fr' : '1fr'}
    >
      {showNav && (
        <AddInsuranceModalNavigation
          onPageChange={setPage}
          coverages={coverages}
          onRemove={handleRemoveCoverage}
          page={page}
        />
      )}
      <Box p="6" overflowY="auto">
        {selectedRisk && (
          <RemoveAlertDialog
            isOpen={isOpen}
            onClose={onClose}
            title={t('ARE-YOU-SURE')}
            description={t(
              'ADVISORY-REPORTS_CURRENT-INSURANCE_MODAL_DETAIL_COVERAGE_REMOVE-ALERT',
              { coverage: selectedRisk },
            )}
            onConfirm={() =>
              handleRemoveCoverage(
                coveragesByRisk[selectedRisk.label]?.map(({ id }) => id),
              )
            }
          />
        )}
        <AddInsuranceModalForms
          page={page}
          selectedRisk={selectedRisk?.label}
          selectedRiskId={selectedRisk?.value}
          onRemoveCoverage={onOpen}
          type={type}
          partyType={partyType}
          hideAIBanner={hideAIBanner}
        />
      </Box>
    </ModalBody>
  );
};

export default AddInsuranceModalBody;
